// extracted by mini-css-extract-plugin
export default {"icon":"ExpandToggle__icon___SbXEa","expanded":"ExpandToggle__expanded___NAFnh"};